// Tenantra Inc. - Plain availability label used on public pages
const LABELS = { live: 'Available now', soon: 'Coming soon', beta: 'Partly available' };

export const StatusTag = ({ kind = 'live', label, className = '', ...rest }) => (
  <span className={`inline-flex items-center gap-2 text-xs font-medium ${kind === 'live' ? 'text-teal-800' : 'text-stone-500'} ${className}`} {...rest}>
    <span className={`w-1.5 h-1.5 rounded-full ${kind === 'live' ? 'bg-teal-600' : 'border border-stone-400'}`} />
    {label || LABELS[kind]}
  </span>
);
